import { render, staticRenderFns } from "./LinkSubmenu.vue?vue&type=template&id=2f97884e&scoped=true"
import script from "./LinkSubmenu.js?vue&type=script&lang=js&external"
export * from "./LinkSubmenu.js?vue&type=script&lang=js&external"
import style0 from "./LinkSubmenu.scss?vue&type=style&index=0&id=2f97884e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f97884e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default,HotLink: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Link/Link.vue').default})
